import { apiClient } from './client';

const AUTH_API_BASE_URL = import.meta.env.VITE_API_AUTH_URL;

export interface LoginRequest {
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UpdateProfileRequest {
  first_name?: string;
  last_name?: string;
  gender?: string;
  dob?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: string;
  mobile?: string;
  profile?: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

// Auth Service
class AuthService {
  // POST {VITE_API_AUTH_URL}/auth/login
  async login(credentials: LoginRequest): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/login`, credentials, {
      skipAuth: true,
    });
  }

  // POST {VITE_API_AUTH_URL}/auth/logout  { refreshToken }
  async logout(refreshToken: string): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/logout`, { refreshToken });
  }

  // POST {VITE_API_AUTH_URL}/auth/logout-all
  async logoutAll(): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/logout-all`, {});
  }

  // POST {VITE_API_AUTH_URL}/auth/refresh-token  { refreshToken }
  async refreshToken(data: RefreshTokenRequest): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/refresh-token`, data, {
      skipAuth: true,
    });
  }

  // POST {VITE_API_AUTH_URL}/auth/forgot-password  { email }
  async forgotPassword(data: ForgotPasswordRequest): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/forgot-password`, data, {
      skipAuth: true,
    });
  }

  // POST {VITE_API_AUTH_URL}/auth/profile  (update profile)
  async updateProfile(data: UpdateProfileRequest): Promise<any> {
    return apiClient.put(`${AUTH_API_BASE_URL}/auth/profile`, data);
  }

  // POST {VITE_API_AUTH_URL}/auth/change-password
  async changePassword(data: ChangePasswordRequest): Promise<any> {
    return apiClient.post(`${AUTH_API_BASE_URL}/auth/change-password`, data);
  }

  // Update Profile Picture
  async updateProfilePicture(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.put(`${AUTH_API_BASE_URL}/auth/profile-picture`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

// Export singleton instance
export const authService = new AuthService();
